const imgFiles = [
  { name: "pin1", ext: "webp" },
  { name: "pin2", ext: "webp" },
  { name: "pin3", ext: "webp" },
  { name: "pin4", ext: "webp" },
  { name: "pin5", ext: "webp" },
  { name: "pin6", ext: "webp" },
  { name: "pin7", ext: "webp" },
  { name: "pin9", ext: "webp" },
  { name: "pin10", ext: "webp" },
  { name: "pin11", ext: "webp" },
  { name: "pin12", ext: "webp" },
  { name: "pin13", ext: "webp" },
  { name: "pin14", ext: "webp" },
];

export default imgFiles